import React, { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react'

import * as S from './styles'

export type ButtonTypes =
  | AnchorHTMLAttributes<HTMLAnchorElement>
  | ButtonHTMLAttributes<HTMLButtonElement>

export type ButtonProps = {
  children: React.ReactNode
  initialIcon?: React.ReactElement
  endIcon?: React.ReactElement
  hasSecodaryButton?: boolean
  hasblueButton?: boolean
  hasredButton?: boolean
  as?: React.ElementType
} & ButtonTypes

const Button = ({
  hasSecodaryButton = false,
  hasblueButton = false,
  hasredButton = false,
  children,
  initialIcon,
  endIcon,
  ...props
}: ButtonProps) => (
  <S.Wrapper
    hasSecodaryButton={hasSecodaryButton}
    hasblueButton={hasblueButton}
    hasredButton={hasredButton}
    {...props}
  >
    {initialIcon}
    {children}
    {endIcon}
  </S.Wrapper>
)

export default Button
